import React from 'react';
import Typography from '@bharatpe/bharat-ui/web/Typography';
import UnityLogo from 'assets/images/autoPay/unity-upi.svg';
import './styles.scss';

const UpiPoweredBy: React.FC = () => {
	return (
		<div className="flex flex-column flex-center powered-by-component my3">
			<Typography variant="Regular200" className="title">
				Powered By
			</Typography>
			<div className="flex flex-row">
				<img src={UnityLogo} height={25} width={100} />
			</div>
		</div>
	);
};
export default UpiPoweredBy;
